import React, { useRef, useState, useCallback } from "react";
import { Button, SwipeableDrawer, Box } from "@mui/material";

export default function FileUploadButton({
  label,
  multiple,
  accept,
  enableCamera,
  onChange,
}) {
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);

  const isAndroidCordova =
    enableCamera && window.cordova?.platformId === "android";

  const triggerOnChange = useCallback(
    (file) => {
      if (!file) return;

      const fakeFiles = [file];
//      fakeFiles.item = (i) => fakeFiles[i];

      const fakeEvent = { target: { files: fakeFiles } };
      onChange?.(fakeEvent);
    },
    [onChange],
  );

  const openExplorer = useCallback(() => {
    setOpen(false);
    if (inputRef.current) inputRef.current.value = "";
    setTimeout(() => inputRef.current?.click(), 300);
  }, []);

  const openCamera = useCallback(() => {
    setOpen(false);

    if (!navigator?.camera) return;

    navigator.camera.getPicture(
      (uri) => {
        if (!window.resolveLocalFileSystemURL) return;

        window.resolveLocalFileSystemURL(
          uri,
          (entry) => {
            entry.file(
              (file) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                  if (!reader.result) return;

                  const mimeType = file.type || "image/jpeg";
                  const fileName = file.name || `foto_${Date.now()}.jpg`;

                  const blob = new Blob([reader.result], { type: mimeType });
                  blob.name = fileName
                  blob.lastModifiedDate = Date.now()
//                  const tmpFile = new File([reader.result], fileName, {type: mimeType})

                  triggerOnChange(blob);
                };

                reader.readAsArrayBuffer(file);
              },
              () => {},
            );
          },
          () => {},
        );
      },
      () => {},
      {
        quality: 70,
        destinationType: navigator.camera.DestinationType.FILE_URI,
        sourceType: navigator.camera.PictureSourceType.CAMERA,
        correctOrientation: true,
      },
    );
  }, [triggerOnChange]);

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        accept={accept}
        style={{ display: "none" }}
        onChange={onChange}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={() => (isAndroidCordova ? setOpen(true) : openExplorer())}
      >
        {label}
      </Button>

      {isAndroidCordova && (
        <SwipeableDrawer
          anchor="bottom"
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          PaperProps={{
            sx: { borderTopLeftRadius: 3, borderTopRightRadius: 3, p: 2 },
          }}
        >
          <Box
            p={2}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Button variant="contained" onClick={openCamera}>
              Foto aufnehmen
            </Button>
            <Button variant="outlined" onClick={openExplorer}>
              Datei auswählen
            </Button>
          </Box>
            <div className="ectool-safe-area-top"></div>
        </SwipeableDrawer>
      )}
    </>
  );
}